import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../OrganizationReportUIHelpers";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toMonthName } from "../../../../../config/helper";

// ? LIBRARY TABLE PAGINATION FOR FOLDER WITHOUT PARENT UUID
const OrganizationReportTable = ({
  entities,
  totalCount,
  listLoading,
  queryParams = {},
  setQueryParams,
  openDetailOrganizationReportPage,
  allowEdit
}) => {
  // Table columns
  const columns = [
    {
      dataField: "organization.name",
      text: "Nama Organisasi",
      sort: true
    },
    {
      dataField: "year",
      text: "Tahun",
      sort: true
    },
    {
      dataField: "month",
      text: "Bulan",
      sort: true,
      formatter: cell => {
        return <span>{toMonthName(cell)}</span>;
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: cell => {
        return columnFormatters.StatusColumnFormatter(cell);
      }
    },
    {
      dataField: "dd_fund",
      text: "Dana DD",
      sort: true,
      formatter: cell => {
        return <span>{cell * 100}%</span>;
      }
    },
    {
      dataField: "program_fund",
      text: "Dana Program",
      sort: true,
      formatter: cell => {
        return <span>{cell * 100}%</span>;
      }
    },
    {
      dataField: "utilization_fund",
      text: "Dana Pendayagunaan",
      sort: true,
      formatter: cell => {
        return <span>{cell * 100}%</span>;
      }
    },
    {
      headerClasses: "text-right",
      classes: "text-right",
      text: "Total",
      sort: true,
      formatter: (_, row) => {
        const { zakat, infaq, alms, other } = row;
        const total = +zakat + +infaq + +alms + +other;
        return <span>{currencyFormatter(total)}</span>;
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openDetailOrganizationReportPage,
        allowEdit
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default OrganizationReportTable;
